import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoratnagiricab() {



  const cardData =
  {
    keyword: 'Mumbai to Ratnagiri Cab',
    heading: 'Shambhu Cabs: Mumbai to Ratnagiri Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Ratnagiri Cab services, providing safe, comfortable, and hassle-free travel for families, friends, corporate travelers, and tourists heading to the scenic coastal town of Ratnagiri. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Ratnagiri with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes your coastal trip convenient, stress-free, and memorable. For trusted, comfortable, and safe travel, Shambhu Cabs is your preferred choice for Mumbai to Ratnagiri cab services.',

    top: 'Top Places to Visit in Ratnagiri with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Ganpatipule Beach & Temple",
    "description": "Ganpatipule Beach is a pristine coastline known for its golden sands, clear waters, and serene ambiance. Adjacent to the beach is the Ganpatipule Temple, a 400-year-old shrine dedicated to Lord Ganesha, attracting thousands of devotees. The combination of spiritual significance and natural beauty makes it a must-visit destination in Ratnagiri."
  },
  {
    "title": "Ratnadurg Fort",
    "description": "Ratnadurg Fort, overlooking the Arabian Sea, is a historic coastal fort offering stunning views of the coastline. Visitors can explore ancient ramparts, watchtowers, and a lighthouse. The fort is a perfect blend of history, adventure, and scenic beauty, ideal for photography and exploration."
  },
  {
    "title": "Thibaw Palace",
    "description": "Thibaw Palace, also known as Sawantwadi Palace, is an architectural marvel reflecting traditional Konkan design. Once home to King Thibaw of Burma, the palace showcases intricate woodwork, royal artifacts, and historical exhibits. It is a cultural landmark offering insight into Ratnagiri’s royal past."
  },
  {
    "title": "Aare Ware Beach",
    "description": "Aare Ware Beach is a quiet and less crowded beach in Ratnagiri, known for its natural beauty, rock formations, and sunset views. It is ideal for peaceful walks, meditation, photography, and enjoying the tranquility of the Konkan coast away from the tourist bustle."
  },
  {
    "title": "Jaigad Fort",
    "description": "Jaigad Fort, perched on a cliff at the confluence of the Arabian Sea and local rivers, is a historic coastal fortification. Visitors can explore bastions, cannons, and scenic viewpoints. The fort offers spectacular views of the sea and surrounding landscapes, making it a favorite spot for history enthusiasts and photographers."
  },
  {
    "title": "Bhatye Beach",
    "description": "Bhatye Beach is a popular beach in Ratnagiri town, known for its calm waters and vibrant local culture. Visitors enjoy beach walks, local seafood, and witnessing daily fishing activities. The beach is ideal for relaxation, photography, and experiencing Ratnagiri’s coastal life."
  },
  {
    "title": "Marleshwar Cave Temple",
    "description": "Marleshwar Cave Temple, nestled in the Sahyadri hills, is a scenic temple dedicated to Lord Shiva. Visitors trek through lush forests and waterfalls to reach the temple, which features a natural cave and a peaceful sanctum. It is a perfect blend of adventure, spirituality, and nature exploration."
  },
  {
    "title": "Velneshwar Beach & Temple",
    "description": "Velneshwar Beach is a serene beach known for its quiet atmosphere, surrounded by coconut groves and small fishing villages. The nearby Velneshwar Shiva Temple adds spiritual significance. The location is ideal for meditation, leisure walks, and experiencing the local Konkan lifestyle."
  },
  {
    "title": "Tung Fort",
    "description": "Tung Fort, located near Ratnagiri, is a hill fort offering panoramic views of the surrounding mountains, valleys, and villages. It is popular among trekkers for its moderate trail and scenic vistas. The fort’s strategic location and historical importance make it an engaging destination for adventure seekers."
  },
  {
    "title": "Swami Swarupanand Mandir",
    "description": "Swami Swarupanand Mandir is a spiritual and cultural center in Ratnagiri, attracting devotees and visitors interested in learning about local religious traditions. The temple complex hosts festivals, rituals, and spiritual gatherings, offering a peaceful retreat and insight into the region’s cultural heritage."
  }
],




"services": [
  {
    "name": "Mumbai Ratnagiri Taxi",
    "description": "Mumbai Ratnagiri Taxi provides comfortable and reliable travel from Mumbai to Ratnagiri with professional drivers, timely pickups, and clean vehicles for a stress-free journey."
  },
  {
    "name": "Ratnagiri from Mumbai Cab",
    "description": "Ratnagiri from Mumbai Cab ensures a smooth and convenient ride from Mumbai to the Konkan coast, suitable for both leisure travelers and business commuters."
  },
  {
    "name": "Konkan Cab Mumbai Ratnagiri",
    "description": "Konkan Cab Mumbai Ratnagiri specializes in scenic rides along the Konkan route, offering SUV and sedan options for family trips and long-distance travel."
  },
  {
    "name": "One Way Cab Mumbai Ratnagiri",
    "description": "One Way Cab Mumbai Ratnagiri is perfect for travelers looking for a single-direction ride, offering affordable fares and reliable service from Mumbai to Ratnagiri."
  },
  {
    "name": "Affordable Cab Mumbai Ratnagiri",
    "description": "Affordable Cab Mumbai Ratnagiri provides cost-effective travel without compromising on comfort, safety, or service quality for your long-distance journey."
  },
  {
    "name": "SUV Cab Mumbai Ratnagiri",
    "description": "SUV Cab Mumbai Ratnagiri is ideal for families or groups, offering spacious and comfortable rides for long-distance travel along the Konkan coast."
  },
  {
    "name": "Sedan Cab Mumbai Ratnagiri",
    "description": "Sedan Cab Mumbai Ratnagiri provides an economical and comfortable option for small families or solo travelers, with AC sedans like Dzire or Etios."
  },
  {
    "name": "24x7 Taxi Mumbai Ratnagiri",
    "description": "24x7 Taxi Mumbai Ratnagiri ensures round-the-clock availability for early morning or late-night departures, providing reliable service anytime."
  },
  {
    "name": "Mumbai Ratnagiri Outstation Cab",
    "description": "Mumbai Ratnagiri Outstation Cab offers hassle-free long-distance travel with professional drivers, comfortable vehicles, and timely service for a smooth journey."
  },
  {
    "name": "Fast Cab Mumbai Ratnagiri",
    "description": "Fast Cab Mumbai Ratnagiri provides quick and efficient travel using optimized routes to ensure timely arrivals at Ratnagiri from Mumbai."
  },
  {
    "name": "Mumbai Ratnagiri Highway Cab",
    "description": "Mumbai Ratnagiri Highway Cab ensures a comfortable ride on the expressway with smooth driving, AC vehicles, and experienced drivers for long-distance travel."
  },
  {
    "name": "Family Cab Mumbai Ratnagiri",
    "description": "Family Cab Mumbai Ratnagiri provides spacious and safe vehicles for family trips, ensuring comfort and convenience throughout the journey."
  },
  {
    "name": "Premium Cab Mumbai Ratnagiri",
    "description": "Premium Cab Mumbai Ratnagiri offers luxury sedans and SUVs for passengers seeking extra comfort, style, and a high-end travel experience."
  },
  {
    "name": "Long Route Taxi Mumbai Ratnagiri",
    "description": "Long Route Taxi Mumbai Ratnagiri is ideal for travelers covering long distances with comfort, safety, and professional service throughout the journey."
  },
  {
    "name": "Safe Cab Mumbai Ratnagiri",
    "description": "Safe Cab Mumbai Ratnagiri focuses on passenger safety with well-maintained vehicles, trained drivers, and strict adherence to traffic rules."
  },
  {
    "name": "Best Cab Mumbai Ratnagiri",
    "description": "Best Cab Mumbai Ratnagiri provides top-rated taxi service with punctual drivers, clean vehicles, and reliable long-distance travel from Mumbai to Ratnagiri."
  }
],

"tableData": [
  ["Mumbai Ratnagiri Taxi", "Ratnagiri from Mumbai Cab"],
  ["Konkan Cab Mumbai Ratnagiri", "One Way Cab Mumbai Ratnagiri"],
  ["Affordable Cab Mumbai Ratnagiri", "SUV Cab Mumbai Ratnagiri"],
  ["Sedan Cab Mumbai Ratnagiri", "24x7 Taxi Mumbai Ratnagiri"],
  ["Mumbai Ratnagiri Outstation Cab", "Fast Cab Mumbai Ratnagiri"],
  ["Mumbai Ratnagiri Highway Cab", "Family Cab Mumbai Ratnagiri"],
  ["Premium Cab Mumbai Ratnagiri", "Long Route Taxi Mumbai Ratnagiri"],
  ["Safe Cab Mumbai Ratnagiri", "Best Cab Mumbai Ratnagiri"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Ratnagiri Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Ratnagiri cab services, perfect for long-distance travel, family trips, weekend getaways, and comfortable coastal journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to enjoy a smooth and comfortable ride from Mumbai to Ratnagiri."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Ratnagiri route, ensuring safe driving, timely arrivals, and a stress-free travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We offer clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included for your Mumbai to Ratnagiri cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route guidance, and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel packages to suit your Mumbai to Ratnagiri journey."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai to Ratnagiri journey smooth, comfortable, and worry-free."
  }
]































  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Ratnagiri?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services from Mumbai to Ratnagiri, ensuring a smooth and scenic journey to this beautiful coastal city.',
  },
  {
    question: 'How can I book a cab from Mumbai to Ratnagiri?',
    answer: 'You can easily book a cab from Mumbai to Ratnagiri via our website, mobile app, or by contacting our 24x7 customer support team for a hassle-free experience.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Ratnagiri cab bookings?',
    answer: 'Shambhu Cabs offers a range of vehicles for the Mumbai to Ratnagiri trip, including sedans, SUVs, luxury cars, and Tempo Travellers for larger groups or family trips.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Ratnagiri journey?',
    answer: 'Yes, our drivers are licensed, professional, and well-versed with the route from Mumbai to Ratnagiri, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai to Ratnagiri trip?',
    answer: 'Yes, you can choose your preferred pickup and drop-off points in Mumbai and Ratnagiri, making the journey more personalized and convenient.',
  },
  {
    question: 'Is the Mumbai to Ratnagiri cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs provides 24x7 service for your journey from Mumbai to Ratnagiri, allowing you to travel at any time that suits your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Ratnagiri trip?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure your well-being during the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Ratnagiri cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for Mumbai to Ratnagiri cab bookings.',
  },
  {
    question: 'Is customer support available during my Mumbai to Ratnagiri trip?',
    answer: 'Yes, Shambhu Cabs offers 24x7 customer support to assist you during your journey from Mumbai to Ratnagiri.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Chavan',
    feedback: 'Our journey from Mumbai to Ratnagiri with Shambhu Cabs was delightful. The driver was professional, the vehicle was clean and well-maintained, and the ride was smooth.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Malhotra',
    feedback: 'Shambhu Cabs made our trip from Mumbai to Ratnagiri very comfortable and hassle-free. Great service, punctual drivers, and smooth ride all the way.',
    rating: 5,
  },
];














































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];









const mumbaiRatnagiriCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Ratnagiri Cab",
  "serviceType": "Outstation / Intercity Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-ratnagiri-cab.jpg",
  "description": "Shambhu Cabs provides reliable Mumbai to Ratnagiri cab services. Book affordable SUV, sedan, and premium cabs for one-way, round trip, family, or business travel, available 24×7.",
  "brand": { "@type": "Brand", "name": "Shambhu Cabs" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "720",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-ratnagiri-cab"
  },
  "areaServed": { "@type": "Place", "name": "Mumbai, Ratnagiri, India" }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to Ratnagiri Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Ratnagiri cab services with Shambhu Cabs. Affordable SUV, sedan, and premium cabs for one-way, round trip, family, or business travel, available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Ratnagiri Taxi, Ratnagiri from Mumbai Cab, Konkan Cab Mumbai Ratnagiri, One Way Cab Mumbai Ratnagiri, Affordable Cab Mumbai Ratnagiri, SUV Cab Mumbai Ratnagiri, Sedan Cab Mumbai Ratnagiri, 24x7 Taxi Mumbai Ratnagiri, Mumbai Ratnagiri Outstation Cab, Fast Cab Mumbai Ratnagiri, Mumbai Ratnagiri Highway Cab, Family Cab Mumbai Ratnagiri, Premium Cab Mumbai Ratnagiri, Long Route Taxi Mumbai Ratnagiri, Safe Cab Mumbai Ratnagiri, Best Cab Mumbai Ratnagiri"
  />

  <script type="application/ld+json">
    {JSON.stringify(mumbaiRatnagiriCabSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/66.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoratnagiricab;